import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  FormClose,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Alert,
  Link,
  Cursor,
  System,
  Video,
  Codepen,
  Gateway,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import SyncLoader from "react-spinners/SyncLoader";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import LiveDemoDetail from "./LiveDemoDetail";
import DocContentDetail from "./DocContentDetail";
import MMContentDetail from "./MMContentDetail";
import ListView from "./ListView";

class SearchHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prodMatches: undefined,
      contentSelected: undefined,
      bShowprodMatches: false,
      bshowSrchTxtloader: false,
      SrchResData: undefined,
      SrchValue: undefined,
      bOpenListView: false,
      bOpenContentDetail: false,
    };
    // this.openGLCP = this.openGLCP.bind(this);
    this._onSrchTextChange = this._onSrchTextChange.bind(this);
    this.OnPrdClicked = this.OnPrdClicked.bind(this);
    this.srchBytxt = this.srchBytxt.bind(this);
    this._hideContent = this._hideContent.bind(this);
    this.closeListView = this.closeListView.bind(this);
    this.closeContents = this.closeContents.bind(this);
  }

  componentDidMount() {
    // console.log("Products received as Pops from Header are ", this.props.Prods);
    console.log("Search Handler initiated");
  }

  _hideContent() {
    //this.setState({ contentSelected: undefined, bOpenContentDetail: false });
    //this.props.hide();
    this.setState({ bOpenContentDetail: false });
  }

  closeContents() {
    this.setState({
      bOpenContentDetail: false,
      SrchResData: undefined,
      SrchValue: undefined,
    });
  }

  closeListView() {
    this.setState({ bOpenListView: false });
  }

  _onSrchTextChange(event) {
    if (event.target.value.length >= 3) {
      console.log("Search Text Changed with value ", event.target.value);
      console.log("Search Text Changed with keypress ", event.key);
      //var prdArr = new Array();
      if (event.key === "Enter") {
        this.setState({ SrchValue: event.target.value, bOpenListView: true });
      } else {
        /*         var prdtemplst = this.props.Prods.filter((p) =>
          p.ProductName.toLowerCase().includes(event.target.value.toLowerCase())
        );
        var PrdArr = prdtemplst.map((pp) => {
          return pp.ProductName;
        });
        if (PrdArr != undefined && PrdArr.length > 0) {
          this.setState({ prodMatches: PrdArr, bShowprodMatches: true });
        } */
        this.srchBytxt(event.target.value);
      }
    } else {
      this.setState({
        prodMatches: undefined,
        bShowprodMatches: false,
        bshowSrchTxtloader: false,
        SrchResData: undefined,
      });
    }
  }

  OnPrdClicked(item) {
    console.log("Item selected from list is ", item);
    if (item != null || item != undefined) {
      this.setState({ contentSelected: item, bOpenContentDetail: true });
    }
  }

  srchBytxt(value) {
    var endpoint;
    let token = auth.getToken();
    if (value.length >= 3) {
      endpoint = "/AllContent/SearchAllContentByString/" + value;
      this.setState({ bshowSrchTxtloader: true });
      callApiGetJson(endpoint, token).then((data) => {
        console.log("Search result data from API: for search string " + data);
        if (data != undefined && data.length > 0) {
          this.setState({
            SrchResData: data,
            bshowSrchTxtloader: false,
            //TabIndex: whichTab,
          });
        } else {
          this.setState({
            SrchResData: undefined,
            bshowSrchTxtloader: false,
            //TabIndex: whichTab,
          });
        }
      });
    }
  }

  render() {
    //let FromContentResArr = undefined;

    let bOpenContent = this.state.bOpenContentDetail;
    let itemContent = this.state.contentSelected;
    let itemMM = undefined;
    let itemDoc = undefined;
    let itemDemo = undefined;
    let demoCategory = undefined;

    if (itemContent != undefined && bOpenContent) {
      console.log("From Srch Handler Item is ", itemContent);
      if (itemContent.Content_Type === "Physical") {
        itemDemo = itemContent;
        if (itemContent.PhyContent_Category === "Live") {
          demoCategory = "Live";
        }
        if (itemContent.PhyContent_Category === "Lab") {
          demoCategory = "Lab";
        }
        if (itemContent.PhyContent_Category === "Interactive") {
          demoCategory = "Interactive";
        }
      }
      if (itemContent.Content_Type === "Multimedia") {
        itemMM = itemContent;
      }
      if (itemContent.Content_Type === "Document") {
        itemDoc = itemContent;
      }
      // Here we need to fill respective content types and then based on its content item filled will call respective content detail component
    }

    /*  if (this.state.SrchResData != undefined) {
      FromContentResArr = this.state.SrchResData;
    } */
    return (
      <Main flex={false} fill="horizontal">
        {this.state.SrchValue != undefined && this.state.bOpenListView && (
          <ListView
            srchObj={undefined}
            srchVal={this.state.SrchValue}
            hide={this.closeListView}
            calledBy="From Search"
          />
        )}
        {itemDemo != undefined && bOpenContent && (
          <LiveDemoDetail
            _demoData={itemDemo}
            hide={this._hideContent}
            calledBy="From Search_Item-Selection"
          />
        )}
        {itemMM != undefined && bOpenContent && (
          <MMContentDetail
            _mmContent={itemMM}
            hide={this._hideContent}
            calledBy="From Search_Item-Selection"
          />
        )}
        {itemDoc != undefined && bOpenContent && (
          <DocContentDetail
            _docContent={itemDoc}
            hide={this._hideContent}
            calledBy="From Search_Item-Selection"
          />
        )}
        {/* <Layer
          animate
          modal={true}
          // position="top"
          margin={{ horizontal: "small", top: "small" }}
          // full="horizontal"
          // width="100%"
          // height="50%"
          // height="small"
          // onClickOutside={this.props.hide}
          // onEsc={this.props.hide}
        > */}
        <Box
          align="center"
          justify="center"
          direction="row"
          fill="horizontal"
          margin={{ top: "small", bottom: "small" }}
          // margin={{ top: "small" }}
        >
          {/* <Box
              align="center"
              justify="center"
              background={{ color: "white" }}
              fill="horizontal"
              // margin="largemedium"
            >*/}

          <TextInput
            // icon={<Search />}
            size="large"
            reverse
            placeholder="Search (min 3 chars required)"
            plain={false}
            focusIndicator={true}
            // plain={false}
            //value={this.state.searchValue}
            //suggestions={this.state.suggestions}
            // onSelect={(event) => this._OnSrchTxtSelect(event)}
            onChange={(event) => this._onSrchTextChange(event)}
            onKeyPress={(event) => this._onSrchTextChange(event)}
          />

          <Button
            icon={<FormClose />}
            plain={true}
            focusIndicator={false}
            // onClick={this.props.hide}
            onClick={this.closeContents}
            pad="medium"
            margin={{ horizontal: "medium" }}
          />
          {/* </Box>*/}
        </Box>
        {/*         <Box margin={{ top: "xxsmall" }} justify="start" align="start">
          <Text size="xsmall" color="brand">
            Select content from list below OR Press ENTER
          </Text>
        </Box> */}
        <Box
          align="start"
          justify="start"
          // direction="row"
          // gap="medium"
          fill="horizontal"
          // margin={{ top: "small" }}
          // border={{ side: "bottom" }}
          //overflow="scroll"
        >
          {/* <br />           */}
          {this.state.bshowSrchTxtloader && (
            <Box
              align="center"
              justify="center"
              background="white"
              margin={{ top: "medium", bottom: "large" }}
              //overflow={{ horizontal: "hidden", vertical: "scroll" }}
              fill
            >
              <SyncLoader color="Green" size={15} />
            </Box>
          )}
          {!this.state.bshowSrchTxtloader &&
            this.state.SrchResData != undefined && (
              <Box
                align="start"
                justify="start"
                background="white"
                margin={{ top: "xsmall", bottom: "medium" }}
                // overflow="scroll"
                // direction="column"
                height="small"
                overflow={{ horizontal: "hidden", vertical: "scroll" }}
                // overflow={{ horizontal: "hidden", vertical: "scroll" }}
                // height="xxsmall"
                // pad="small"
                // gap="small"
                border={{ style: "dashed", color: "brand" }}
                //fill="horizontal"
                elevation="medium"
                fill="horizontal"
              >
                <Text alignSelf="start" size="large" color="brand">
                  Select content from list below OR Press ENTER
                </Text>
                <List
                  data={this.state.SrchResData}
                  border={{ side: "bottom" }}
                  secondaryKey={(item) =>
                    item.Content_Type === "Physical" &&
                    item.PhyContent_Category == "Live" ? (
                      <Console color="brand" size="medium" />
                    ) : item.PhyContent_Category == "Lab" ? (
                      <Codepen color="blue!" size="medium" />
                    ) : item.PhyContent_Category == "Interactive" ? (
                      <Gateway color="purple!" size="medium" />
                    ) : item.Content_Type === "Multimedia" ? (
                      <Video color="blue" size="medium" />
                    ) : (
                      <DocumentPdf color="dark-3" size="medium" />
                    )
                  }
                  primaryKey={(item) => (
                    /*  <Box
                        pad="xsmall"
                        margin="xsmall"
                        align="start"
                        justify="start"
                        //fill
                        // border={{ side: "bottom" }}
                        // onClick={this.OnPrdClicked(item)}
                      > */
                    <Text
                      textAlign="start"
                      size="small"
                      color="Black"
                      truncate={false}
                    >
                      {item.Content_Title}
                    </Text>
                    //</Box>
                  )}
                  // step={2}
                  //show={{ page: 7 }}
                  //  paginate
                  onClickItem={(event) => {
                    //setShow(true);
                    this.OnPrdClicked(event.item);
                  }}
                ></List>
              </Box>
            )}
        </Box>
        {/* </Layer> */}
      </Main>
    );
  }
}

export default SearchHandler;
